// extracted by mini-css-extract-plugin
export var circle = "_3r-2";
export var icon = "_3r-a";
export var iconHighlight = "_3r-0";
export var lg = "_3r-8";
export var md = "_3r-7";
export var outline = "_3r-4";
export var sm = "_3r-6";
export var square = "_3r-1";
export var xl = "_3r-9";
export var xs = "_3r-5";
export var xxs = "_3r-3";